import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Breadcrumb, NavigationService } from '../navigation/navigation.service';
import { Observable } from 'rxjs';
@Component({
    selector: 'app-breadcrumbs',
    template: `
        <ng-container *ngIf="(breadcrumbs$ | async) as breadcrumbs">
            <ul class="breadcrumbs-list" *ngIf="breadcrumbs && breadcrumbs.length > 1">
                <li class="breadcrumbs-list-item" *ngFor="let breadcrumb of breadcrumbs; let i = index;" [ngSwitch]="i === breadcrumbs.length - 1">
                    <ng-container *ngSwitchCase="true">
                        {{ breadcrumb.name }}
                    </ng-container>
                    <ng-container *ngSwitchCase="false">
                        <a *ngIf="breadcrumb.url" class="breadcrumbs-link" [routerLink]="breadcrumb.url">
                            {{ breadcrumb.name }}
                        </a>
                    </ng-container>
                </li>
            </ul>
        </ng-container>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent implements OnInit {
    breadcrumbs$: Observable<Breadcrumb[]>;

    constructor(
        private readonly router: Router,
        private readonly navigationService: NavigationService
    ) {}

    ngOnInit() {
        const currentUrl = this.router.url;
        this.breadcrumbs$ = this.navigationService.getBreadcrumb(currentUrl);
    }
}
